{
  "phasePanel": {
    "filesColumnFile": "文件",
    "filesColumnDescription": "说明",
    "filesColumnStatus": "状态"
  },
  "tabs": {
    "plan": "计划",
    "designEffective": "设计有效性",
    "operatingEffective": "运行有效性",
    "report": "报告",
    "ariaLabel": "审计板块"
  },
  "phase": {
    "designEffective": {
      "filesTitle": "设计文档",
      "runsTitle": "设计有效性分析记录",
      "runHeading": "设计有效性分析 {{version}}"
    },
    "operatingEffective": {
      "filesTitle": "日志与记录",
      "runsTitle": "运行有效性分析记录",
      "runHeading": "运行有效性分析 {{version}}"
    }
  },
  "plan": {
    "title": "审计计划",
    "meta": "v{{version}} · {{count}} 项",
    "approved": "已批准",
    "approve": "批准计划",
    "approving": "正在批准…",
    "approveFailed": "无法批准计划。请重试。",
    "approveWarning": "批准计划后将固定项目列表，之后无法再更改。",
    "emptyTitle": "尚无计划",
    "emptyHint": "在下方添加任务说明或范围文档，然后生成计划。",
    "loadFailed": "无法加载计划，请重试。",
    "briefTitle": "任务说明（可选）",
    "scopeTitle": "范围文档",
    "scopeUpload": "上传范围文档",
    "scopeUploadFailed": "范围文档上传失败。请重试。",
    "scopeDeleteFailed": "范围文档删除失败。请重试。",
    "readbackFailed": "无法加载计划。请刷新以读取已保存的计划。"
  },
  "files": {
    "phaseRunInProgress": "{{phase}}分析运行期间，暂停上传和修改该阶段的证据。",
    "phaseIngestInProgress": "正在导入{{phase}}证据。请等待完成后再启动该阶段的分析。",
    "serialPipeline": "当前文件处理完成前，两个阶段的上传和处理均需等待。",

    "count_one": "{{count}} 个文件",
    "count_other": "{{count}} 个文件",
    "reading_one": "{{count}} 个正在读取",
    "reading_other": "{{count}} 个正在读取",
    "lockedByRun": "分析进行期间无法添加文件。请等待分析结束后再添加，然后重新运行。",
    "lockedByChecklist": "请先批准本标签页的检查清单，然后再添加文件。"
  },
  "coverage": {
    "title": "覆盖度检查",
    "explain": "Bennie 会将您的文件与本标签页的检查清单逐项比对，在运行分析前告诉您还缺少什么。",
    "waiting": "等待文件读取完成",
    "waitingHint": "文件读取期间无法启动分析。读取完成后即可运行。",
    "checking": "正在检查您的文件",
    "recheck": "重新检查",
    "covered": "{{total}} 项中有 {{covered}} 项已有支持材料",
    "advisory": "您仍然可以运行分析。",
    "unavailable": "尚未对这些文件执行覆盖度检查。",
    "loadFailed": "无法加载覆盖度检查结果，请重试。",
    "stalled": "覆盖检查的时间超出预期。您仍可运行分析，或稍后重新检查。"
  },
  "run": {
    "start": "运行分析",
    "starting": "正在启动…",
    "inProgressHeading": "正在分析各项",
    "itemsAnalysed": "已分析 {{count}} / {{total}} 项",
    "progressUnavailable": "进度暂不可用",
    "startedAt": "开始于 {{time}}",
    "stage": "阶段",
    "stageUnknown": "准备中",
    "stageGenerating": "正在读取您的文件",
    "stageExtracting": "正在汇总发现",
    "stageSequencing": "正在整理发现",
    "stageAggregating": "正在归并问题",
    "stageChecking": "正在检查一致性",
    "stageDone": "正在收尾",
    "columnVersion": "版本",
    "columnStarted": "开始时间",
    "columnStatus": "状态",
    "columnFiles": "文件",
    "columnSummary": "摘要",
    "open": "打开",
    "latest": "最新",
    "emptyTitle": "尚未运行分析",
    "emptyHint": "上传文件后运行分析，即可得到每个检查清单条目的结论。",
    "loadFailed": "无法加载分析记录，请重试。",
    "failedSummary": "分析未能完成，请重试。",
    "status": {
      "queued": "排队中",
      "running": "进行中",
      "completed": "已完成",
      "failed": "已失败"
    },
    "blocked": {
      "ingest_in_progress": "文件仍在读取中。读取完成后再运行分析。",
      "run_in_progress": "已有分析正在运行。请等待其结束后再运行。",
      "report_in_progress": "正在生成报告。请等待其结束后再运行分析。",
      "plan_not_approved": "请先批准计划。",
      "workspace_locked": "该审计已锁定，无法更改。",
      "evidence_not_ingested": "部分已上传的文件尚未摄取。请点击「摄取数据」，然后运行分析。",
      "evidence_ingest_failed": "此项分析的一个文件无法摄取。请删除或重新上传该文件，点击「摄取数据」，然后运行分析。",
      "evidence_deletion_incomplete": "此项分析的一个文件未能完全删除。请再次尝试删除该文件，然后运行分析。",
      "generic": "无法启动分析，请重试。",
      "audit_phase_checklist_not_approved": "请先批准本标签页的检查清单。"
    },
    "admissionLoading": "正在检查是否可以开始分析…",
    "admissionFailed": "无法检查是否可以开始分析。请刷新后重试。"
  },
  "verdict": {
    "Effective": "有效",
    "EffectiveWithExceptions": "有效但存在例外",
    "PartiallyEffective": "部分有效",
    "NotEffective": "无效",
    "NotConcluded": "未得出结论",
    "count": "{{count}} 项{{label}}"
  },
  "runItems": {
    "columnItem": "检查清单条目",
    "columnVerdict": "结论",
    "columnIssues": "问题",
    "analysed": "已分析，等待检查",
    "failed": "分析失败",
    "waiting": "等待中",
    "stateUnavailable": "项目状态暂不可用",
    "empty": "没有可显示的检查清单条目。",
    "exportExcel": "导出为 Excel",
    "exporting": "正在导出……",
    "exportFailed": "Excel 导出失败",
    "columnExplanation": "说明",
    "loadFailed": "无法加载此次分析的检查清单，请重试。",
    "issueLogHeading": "此次分析引出的问题"
  },
  "item": {
    "close": "关闭",
    "findingsHeading": "Bennie 的发现",
    "issuesHeading": "该项引出的问题",
    "noBody": "该项没有已保存的结果。",
    "loadFailed": "无法加载该项，请重试。",
    "breadcrumb": "{{phase}} v{{version}} · {{itemId}}",
    "explanationHeading": "说明",
    "dataGap": "证据不足，无法对该项得出结论。",
    "contextDegraded": "分析该项时有部分参考资料未能使用，因此分析结果可能不完整。请重新运行该阶段后再试。",
    "citedSources": "引用来源"
  },
  "report": {
    "versionLabel": "报告 V{{version}}",
    "current": "当前",
    "generatedAt": "生成于 {{time}}",
    "expand": "展开该版本",
    "collapse": "收起该版本",
    "generateNew": "生成新版本",
    "emptyTitle": "尚无报告",
    "emptyHint": "请先运行两项分析。在设计有效性分析和运行有效性分析各完成一次后即可生成报告。",
    "loadFailed": "无法加载报告版本，请重试。",
    "reingestRequired": "本次审计中的部分文件未能读取，因此无法据此重新生成报告。请重新开始该审计的数据接入，然后再次生成报告。",
    "generateFailed": "无法启动报告生成，请重试。",
    "emptyHintReady": "两项分析均已完成。生成新版本以创建报告。",
    "statusGenerating": "生成中",
    "statusFailed": "失败",
    "failed": {
      "report_generation_crashed": "此版本未能生成。您的分析未被更改。请生成新版本。",
      "report_generation_cancelled": "此版本在完成前已停止。您的分析未被更改。请生成新版本。",
      "auditing_phase2_entered": "此版本在更改任何分析结果之前已停止，未删除任何内容。请生成新版本。",
      "report_version_settle_failed": "此版本已完成，但未能保存为当前报告。您的分析未被更改。请生成新版本。",
      "report_overarching_failed": "此版本未能生成其报告级问题。您的分析未被更改。请生成新版本。",
      "report_overarching_not_done": "此版本在缺少报告级问题的情况下完成，因此未保存为当前报告。您的分析未被更改。请生成新版本。",
      "report_cohort_park_unreachable": "此版本在存在无法重试或接受的章节时停止。您的分析未被更改。请生成新版本。",
      "generic": "此版本未能生成。您的分析未被更改。请生成新版本。",
      "halted": "此版本因上游问题导致生成暂停而停止。您的分析未被更改。请使用「{{clearHalt}}」恢复，然后生成新版本。"
    },
    "blocked": {
      "plan_not_stable": "请先批准计划。",
      "ingest_in_progress": "您的文件仍在读取中。读取完成后再生成报告。",
      "run_in_progress": "分析仍在运行。分析完成后再生成报告。",
      "report_in_progress": "已有一个报告版本正在生成。请等待其完成。",
      "report_version_in_progress": "已有一个报告版本正在生成。请等待其完成。",
      "report_runs_incomplete": "生成报告需要一次已完成的设计有效性分析和一次已完成的运行有效性分析。请先运行缺少的那一项，然后再生成报告。",
      "report_generation_unfinished": "上一个报告版本未完成。请在下方打开它，在每个未完成的章节上使用「反馈」或「从头重试」，所有章节完成后再生成新版本。",
      "generation_in_progress": "报告版本正在生成中。请等待其完成后再生成。"
    },
    "preflightTitle": "生成新版本",
    "preflightIntro": "新版本将基于以下已批准的检查清单和已完成的分析生成。",
    "preflightChecklist": "检查清单 v{{version}} · {{count}} 项",
    "preflightNoChecklist": "没有已批准的检查清单",
    "preflightRun": "分析 v{{version}} · {{status}}",
    "preflightNoRun": "没有已完成的分析",
    "preflightCancel": "取消",
    "preflightFailed": "无法加载新版本将使用的内容，请重试。",
    "exportExcel": "导出为 Excel",
    "exporting": "正在导出……",
    "exportFailed": "Excel 导出失败",
    "preflightLoading": "正在检查报告是否就绪…",
    "sectionsBeingWritten": "正在撰写各章节。",
    "references": {
      "count_one": "{{count}} 份文档",
      "count_other": "{{count}} 份文档",
      "location": "位置",
      "content": "内容"
    },
    "issues": {
      "title": "问题日志",
      "count_one": "{{count}} 个问题",
      "count_other": "{{count}} 个问题",
      "finding": "发现"
    }
  },
  "chat": {
    "open": "询问 Bennie",
    "collapse": "收起",
    "title": "询问 Bennie",
    "ariaExpand": "打开对话",
    "ariaCollapse": "关闭对话",
    "answeringFor": "正在回答：{{tab}}"
  },
  "checklist": {
    "titleDe": "设计检查清单",
    "titleOe": "运行检查清单",
    "meta": "v{{version}} · {{count}} 项",
    "approved": "已批准",
    "approve": "批准检查清单",
    "approving": "正在批准……",
    "approveWarning": "批准后检查清单的条目将被固定，之后无法再修改。",
    "loadFailed": "无法加载检查清单，请重试。",
    "loading": "正在加载检查清单……",
    "lockedByPlan": "请先批准计划，然后才能创建设计检查清单。",
    "lockedByDe": "请先批准设计检查清单，然后才能创建运行检查清单。",
    "generate": "生成检查清单",
    "generating": "正在生成……",
    "generatingHint": "这可能需要几分钟。",
    "emptyHintDe": "Bennie 会根据您已批准的计划生成设计检查清单。",
    "emptyHintOe": "Bennie 会根据您已批准的设计检查清单生成运行检查清单。",
    "edit": "编辑",
    "remove": "删除",
    "add": "+ 添加条目",
    "save": "保存",
    "saving": "正在保存……",
    "cancel": "取消",
    "required": "必填",
    "fieldTitle": "条目",
    "fieldDescription": "检查内容",
    "fieldMethod": "方法",
    "fieldMethodOptional": "检查方法（可选）",
    "fieldRefs": "所测试的设计条目",
    "testsDesignItems": "测试：{{items}}",
    "actionFailed": "无法保存该修改，请重试。",
    "generationStalled": "检查清单的生成时间超出预期。请刷新页面查看，或重新生成。",
    "retry": "重试",
    "generationIncomplete": "检查清单未能生成，请重试。"
  },
  "failure": {
    "timedOut": "处理时间超出预期，请重试。",
    "network": "无法连接到 Bennie，请检查网络连接后重试。",
    "unexpectedResponse": "Bennie 返回了意外的结果，请重试。"
  },
  "scrollLines": {
    "goTo": "跳转到第 {{index}} 节（共 {{count}} 节）"
  }
}
